import { styled } from 'styled-components'

export const SwitchWrapper = styled.div`
    width: 100%;
    padding-top: ${props => `${props.theme.paddingXXS}px`};
    display: flex;
    justify-content: space-between;
`
